import React, { FC, useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import BlogPostApi from '../../../../infrastructure/api/BlogPostApi'
import { IBlogPostModel } from '../../../../models/responses/BlogPostModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { LanguageEnum } from '../../../../enums/LanguageEnum'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { GenericTable } from '../../../components/tables/GenericTable'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const BlogPostListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [blogPosts, setBlogPosts] = useState<PagedResponseModel<IBlogPostModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('date_desc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getBlogPosts() {
      var response = await BlogPostApi.GetBlogPosts(paginationFilter)
      setBlogPosts(response.data)
    }
    getBlogPosts()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Blog Posts'
        data={blogPosts?.items}
        currentTotalRecords={blogPosts?.totalRecords!!}
        currentPageNumber={blogPosts?.pageNumber!!}
        columns={[
          {
            label: 'Type',
            name: 'name',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return (
                  <div className='text-dark fw-bolder text-hover-primary d-block fs-6 mw-100'>
                    {blogPosts?.items[dataIndex].postType == 1 ? (
                      <KTSVG
                        path='/media/icons/duotone/Home/Picture.svg'
                        className='svg-icon-4x svg-icon-gray-600'
                      />
                    ) : blogPosts?.items[dataIndex].postType == 2 ? (
                      <KTSVG
                        path='/media/icons/duotone/Devices/Video-camera.svg'
                        className='svg-icon-4x svg-icon-gray-600'
                      />
                    ) : blogPosts?.items[dataIndex].postType == 5 ? (
                      <KTSVG
                        path='/media/icons/duotone/General/Attachment2.svg'
                        className='svg-icon-4x svg-icon-gray-600'
                      />
                    ) : (
                      <KTSVG
                        path='/media/icons/duotone/Text/Quote1.svg'
                        className='svg-icon-4x svg-icon-gray-600'
                      />
                    )}
                  </div>
                )
              },
              sort: false
            },
          },
          {
            label: 'Post Name',
            name: 'name',
            options: {
              customBodyRender: (value) => {
                return <div style={{ width: 230 }}>{value}</div>
              },
            },
          },
          { label: 'Category', name: 'blogCategoryName', options: { sort: false } },
          {
            label: 'Date',
            name: 'date',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return (
                  <div className='d-flex'>{blogPosts?.items[dataIndex].date.split('T', 1)}</div>
                )
              },
            },
          },
          {
            label: 'Language',
            name: 'language',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{LanguageEnum[value]}</div>
              },
            },
          },
          {
            label: 'Active',
            name: 'isActive',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return (
                  <div className='ps-5 fw-bolder'>
                    {blogPosts?.items[dataIndex].isActive == true ? '✓' : null}
                  </div>
                )
              },
            },
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={blogPosts?.items[dataIndex]?.id!!}
                    itemParam={blogPosts?.items[dataIndex]?.name!!}
                    links={[
                      { type: 'edit', value: '/blog/posts/edit/' + blogPosts?.items[dataIndex]?.id!! }
                    ]}
                    types={[TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { BlogPostListModal }
